<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">
        {{
          getProcedureTypes[$route.params.procedureType]
            ? getProcedureTypes[$route.params.procedureType].name
            : ""
        }}
        /
        {{
          centralization
            ? centralization.identifier + " - " + centralization.name
            : ""
        }}
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          apiModuleName="ASSIGNMENT_DOCUMENTS"
          :searchModule="searchModule"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @Btn4="addDocuments"
          @Btn5="closeAssignmentDocument"
          @Btn6="openAddress"
          @Btn7="viewProducts"
          @Btn8="checkApproved"
          @Btn14="viewPdf"
          @Btn42="requestApprove"
          @Btn43="revertSigningFailed"
          @totalRecords="(x) => (totalRecords = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../mixins/assignmentDocumentsPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { ASSIGNMENT_DOCUMENTS, GET_PAAP_CENTRALIZATION } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import AssignmentProducts from "@/components/assignment-products/AssignmentProducts";
import { mapMutations, mapGetters } from "vuex";
import Command1 from "@/components/Command1";
import { AssignmentDocumentType } from "../common/types/command.type.js";
import AssignmentDocuments from "@/components/AssignmentDocuments";

export default {
  name: "Achizitii",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      centralization: null,
      tableHead: [
        {
          title: "Număr achiziție",
          sort: true,
          queryKey: "assignmentNumber",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Data achiziție",
          queryKey: "assignmentDate",
          bottomHead: {
            quikFiltre: "date",
          },
        },
        {
          title: "Furnizor",
          queryKey: "institutionProvider.name",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare totală fără TVA",
          queryKey: "totalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cotă TVA",
          queryKey: "tvaValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare totală cu TVA",
          queryKey: "totalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          spacer: true,
          minimize: 1,
          fixed: {
            right: true,
          },
          queryKey: "status",
          bottomHead: {
            quikFiltre: "assignmentDocumentStatus",
          },
        },
      ],
      tableModule: (x, y) =>
        ASSIGNMENT_DOCUMENTS.get(
          x,
          y,
          `eq=paapCentralizationId,${this.$route.params.centralization}`
        ),
      searchModule: (x, y, _, query) => {
        let filter = `eq=paapCentralizationId,${this.$route.params.centralization}`;

        if (query) {
          filter += `&${query}`;
        }

        return ASSIGNMENT_DOCUMENTS.get(x, y, filter);
      },
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview"]),

    reload() {
      this.reloadTable++;
    },
    openAddress(item) {
      window.open(item.conectxAddressUrl, "_blank");
    },
    revertSigningFailed(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.setLoad(true);
      ASSIGNMENT_DOCUMENTS.revertSigningFailed(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Comanda a revenit în starea generat.");
          } else {
            this.$toastr.w(res.response || res.message || "A apărut o eroare.");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toastr.e("A apărut o eroare.");
        })
        .finally(() => {
          this.reload();
          this.setLoad();
        });
    },
    prepareData(row) {
      const preparation = [
        row.assignmentNumber || "",
        this.toDate(row.assignmentDate) || "",
        row.institutionProvider?.name || "",
        this.prepareLocaleNumber(row.totalValueWithoutTva) || "",
        this.prepareLocaleNumber(row.tvaValue) || "",
        this.prepareLocaleNumber(row.totalValueWithTva) || "",
        {
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Draft",
          },
          generated: {
            border: "left",
            icon: "fas fa-pencil",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Generat",
          },
          waiting_approve: {
            border: "left",
            icon: "fas fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Așteptare aprobare",
          },
          signing_failed: {
            border: "left",
            icon: "fas fa-exclamation-triangle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Semnare eșuată",
          },
          rejected: {
            border: "left",
            icon: "fas fa-times-circle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Respins",
          },
          approved: {
            border: "left",
            icon: "fas fa-clipboard-check",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Aprobat",
          },
          closed: {
            border: "left",
            icon: "fas fa-badge-check",
            css: "padding: 0.5rem;color: green;font-size: 2rem;",
            tooltip: "Finalizat",
          },
        }[row.status] || "-",
      ];

      const x = this.PERMISIONS;

      const prepareBtn = [];
      prepareBtn.push([7, "Produse"]);

      if (row.status != "draft") {
        prepareBtn.push(14);
      }
      if (
        row.status != "approved" &&
        row.status != "waiting_approve" &&
        row.status != "signing_failed" &&
        row.assignmentType != AssignmentDocumentType.ComandaFermaTip3 &&
        row.status != "closed"
      ) {
        prepareBtn.push(2);
      }

      if (row.status == "generated" || row.status == "rejected") {
        prepareBtn.push([
          42,
          "Trimite spre semnare",
          ["fas fa-signal-stream", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (row.status == "waiting_approve") {
        prepareBtn.push([
          6,
          "Deschide lucrarea",
          ["fas fa-book", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (
        row.status != "approved" &&
        row.status != "waiting_approve" &&
        row.status != "closed"
      ) {
        prepareBtn.push(3);
      }
      if (row.status == "approved") {
        prepareBtn.push([
          4,
          "Documente",
          ["fas fa-file-plus", "font-size:2.2rem; color: #337ab7;"],
        ]);
        prepareBtn.push([
          5,
          "Finalizează achiziția",
          ["fas fa-badge-check", "font-size:2.2rem; color: green;"],
        ]);
      }

      if (row.status == "closed") {
        prepareBtn.push([
          4,
          "Documente",
          ["fas fa-file-plus", "font-size:2.2rem; color: #337ab7;"],
        ]);
      }

      if (row.status == "waiting_approve" && x.edit === true) {
        prepareBtn.push([
          8,
          "Verifică aprobare",
          ["fas fa-sync", "font-size:2.2rem; color:#F2994A;"],
        ]);
      }

      if (row.status == "signing_failed" && x.edit === true) {
        prepareBtn.push([
          43,
          "Revenire din semnare eșuată",
          ["fas fa-redo", "font-size:2.2rem;color:#39f;"],
        ]);
      }
      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return preparation;
    },

    viewPdf(data) {
      this.setReferenceIdForPreview({
        data: {
          id: data.id,
        },
        origin: "ASSIGNMENT_PDF",
      });
    },

    changeStatus(data, status) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare semanre.");
        this.reload();
        this.setLoad();
      };

      this.setSafeLoad(12000);
      ASSIGNMENT_DOCUMENTS.approve(data.id, { status })
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Acțiune efectuată cu succes.");

            this.reload();
            this.setLoad();
          } else {
            error(res.response);
          }
        })
        .catch(error);
    },

    requestApprove(data) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare semanre.");
        this.reload();
        this.setLoad();
      };

      this.setSafeLoad(12000);
      ASSIGNMENT_DOCUMENTS.requestApprove(data.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            window.open(res.data.result.url, "_blank");
            this.reload();
            this.setLoad();
          } else {
            error(res.response);
          }
        })
        .catch(error);
    },

    viewProducts(item) {
      this.$modal.show(
        DialogModal,
        {
          target: "AssignmentProducts",
          title: "Produse",
          inputs: [
            {
              id: "assignmentProducts",
              type: "component",
              component: AssignmentProducts,
              componentProps: { assignmentDocument: item },
            },
          ],
          closeBtnText: "Anulează",

          button: {
            type: 2,
            value: "Generează",
            disabled:
              item.status == "waiting_approve" ||
              item.status == "signing_failed" ||
              item.status == "approved" ||
              item.status == "closed",
            handler: (sendData) => {
              const data = sendData.assignmentProducts;

              const error = (msg) => {
                this.$toastr.e(msg || "Generarea a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              ASSIGNMENT_DOCUMENTS.generate(data.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Generarea comenzii ferme s-a efectuat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },

          customClass: "custom-size",
        },
        {
          name: "AssignmentProducts",
          adaptive: true,
          width: "100%",
          height: "100%",
        }
      );
    },
    async checkProduct(item) {
      if (!item) return;
      ASSIGNMENT_DOCUMENTS.getOne(item)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const assignmentDocument = res.data;
            this.$router.replace(this.$route.path);
            this.viewProducts(assignmentDocument);
          } else {
            this.$toastr.e("Achiziția nu a fost găsită.");
          }
        })
        .catch(() => {
          this.$toastr.e("Achiziția nu a fost găsită.");
        });
    },

    editItem(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Salvarea achiziției a eșuat.");
        this.setLoad();
      };

      this.setLoad(true);

      ASSIGNMENT_DOCUMENTS.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const assignment = res.data;

            this.$modal.show(
              DialogModal,
              {
                target: assignment.assignmentType,
                title: this.assignmentTitle[assignment.assignmentType],
                inputs: [
                  {
                    id: "cmd",
                    type: "component",
                    component: Command1,
                    componentProps: {
                      initial: { ...assignment },
                      assignmentType: assignment.assignmentType,
                    },
                  },
                ],
                acceptFinish: (data) => {
                  const cmd = data.cmd;

                  delete cmd.conectxAddressUrl;
                  delete assignment.conectxAddressUrl;
                  delete cmd.conectxAddressUuid;
                  delete assignment.conectxAddressUuid;
                  delete cmd.registrationDate;
                  delete cmd.registrationDatetime;
                  delete cmd.registrationNumber;
                  delete assignment.registrationDate;
                  delete assignment.registrationNumber;
                  delete assignment.registrationDatetime

                  if (cmd.filesConverting) {
                    this.$toastr.w("Fișierele se convertesc în PDF...");
                    return false;
                  }
                  delete cmd.filesConverting;

                  const documents = cmd.documents || [];
                  delete cmd.documents;
                  delete assignment.documents;

                  if (
                    assignment.assignmentType ===
                      AssignmentDocumentType.ComandaFermaTip1 &&
                    documents.filter((e) => !e.deleted).length === 0
                  ) {
                    this.$toastr.w(
                      "Nu a fost atașat nici un document justificativ."
                    );
                    return false;
                  }

                  for (const key in cmd) {
                    if (!cmd[key]) {
                      this.$toastr.w("Nu au fost completate toate secțiunile.");
                      return false;
                    }

                    if (key === "departments" && cmd[key].length === 0) {
                      this.$toastr.w("Nu a fost selectat nici un departament.");
                      return false;
                    }
                  }


                  const changedFields = this.getEdited(
                    {
                      ...assignment,
                      totalValueWithTva: Number(assignment.totalValueWithTva),
                      totalValueWithoutTva: Number(
                        assignment.totalValueWithoutTva
                      ),
                    },
                    {
                      ...cmd,
                      assignmentDate: new Date(
                        cmd.assignmentDate
                      ).toISOString(),
                    }
                  );

                  if (
                    assignment.institutionProvider.cui !==
                    cmd.institutionProviderCui
                  ) {
                    changedFields.institutionProviderCui =
                      cmd.institutionProviderCui;
                  }

                  const documentChanges = {
                    toDelete: documents
                      .filter((e) => e.deleted && e.keyFilename)
                      .map((e) => e.keyFilename),
                    toUpload: documents.filter(
                      (e) =>
                        !e.deleted && !e.keyFilename && e.file instanceof File
                    ),
                  };

                  const hasRenames = documents.some(
                    (e) =>
                      !e.deleted &&
                      e.keyFilename &&
                      e.file.name !== e.originalName
                  );

                  if (hasRenames) {
                    changedFields.documents = documents
                      .filter((e) => e.keyFilename)
                      .map((e) => ({
                        key: e.keyFilename,
                        name: e.file.name,
                      }));
                  }

                  const hasDocumentChanges =
                    documentChanges.toDelete.length > 0 ||
                    documentChanges.toUpload.length > 0 ||
                    hasRenames;

                  if (!Object.keys(changedFields).length && !hasDocumentChanges) {
                    this.$toastr.w("Nu au fost găsite modificări.");
                    return false;
                  }

                  data.cmd = changedFields;
                  data.documentChanges = documentChanges;

                  return true;
                },
                closeBtnText: "Anulează",
                button: {
                  type: 2,
                  value: "Salvează",
                  handler: async (data) => {
                    this.setLoad();

                    const finish = async () => {
                      if (
                        item.assignmentType ===
                        AssignmentDocumentType.ComandaFermaTip1
                      ) {
                        await this.applyDocumentChanges(
                          item.id,
                          data.documentChanges
                        );
                      }

                      this.setLoad();
                      this.reload();
                    };

                    if (!Object.keys(data.cmd).length) {
                      await finish();
                      return;
                    }

                    ASSIGNMENT_DOCUMENTS.edit(item.id, {
                      ...data.cmd,
                    })
                      .then(async (res) => {
                        if (
                          this.checkHttpStatusCode(res?.meta?.HttpStatusCode)
                        ) {
                          this.$toastr.s("Achiziția a fost salvată.");

                          await finish();
                        } else {
                          if (this.isObject(res?.response)) {
                            error(res?.response?.message);
                          } else {
                            error(res?.response);
                          }
                        }
                      })
                      .catch(error);
                  },
                },
                customClass: "full-dialog",
              },
              {
                name: item.assignmentType,
                adaptive: true,
                width: "900px",
                height: "800px",
              }
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });

      this.setLoad();
    },

    deleteItem(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteAssignmentDocument",
          title: "Șterge achiziție",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Achiziția nu a fost ștearsă.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              ASSIGNMENT_DOCUMENTS.delete(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Achiziți a fost ștearsă.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteAssignmentDocument",
          adaptive: true,
          width: "650",
          height: "400",
        }
      );
    },
    async applyDocumentChanges(id, changes) {
      if (
        !changes ||
        (!changes.toDelete.length && !changes.toUpload.length)
      ) {
        return;
      }

      let hasErrors = false;

      const error = (res, err) => {
        hasErrors = true;
        const msg = this.isObject(res?.response)
          ? res?.response?.message
          : res?.response || err?.message;
        this.$toastr.e(msg || "Documentele justificative nu au fost salvate.");
      };

      for (const key of changes.toDelete) {
        await ASSIGNMENT_DOCUMENTS.deleteDocument(id, { key })
          .then((res) => {
            if (!this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
              error(res);
            }
          })
          .catch((err) => error(null, err));
      }

      if (changes.toUpload.length > 0) {
        const sendData = new FormData();

        changes.toUpload.forEach((file) => {
          sendData.append("files", file.file);
        });

        await ASSIGNMENT_DOCUMENTS.addDocuments(id, sendData)
          .then((res) => {
            if (!this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
              error(res);
            }
          })
          .catch((err) => error(null, err));
      }

      if (!hasErrors) {
        this.$toastr.s("Documentele justificative au fost actualizate.");
      }
    },

    addDocuments(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Documentele nu a fost încărcate.");
        this.reload();
        this.setLoad();
      };

      this.setLoad(true);

      ASSIGNMENT_DOCUMENTS.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const assignment = res.data;
            this.$modal.show(
              DialogModal,
              {
                target: "AddDocuments",
                title: "Adaugare document",
                inputs: [
                  {
                    id: "assignmentDocumentFiles",
                    type: "component",
                    component: AssignmentDocuments,
                    componentProps: { assignmentDocument: assignment },
                    errReason: "Nu a fost încărcat nici un fișier.",
                  },
                ],
                closeBtnText: "Anulează",
                button: {
                  type: 2,
                  value: "Salvează",
                  handler: (data) => {
                    this.setLoad(true);

                    const sendData = new FormData();

                    data.assignmentDocumentFiles
                      .filter((e) => !e.deleted)
                      .forEach((file) => {
                        sendData.append("files", file.file);
                      });

                    ASSIGNMENT_DOCUMENTS.addDocuments(item.id, sendData)
                      .then((res) => {
                        if (
                          this.checkHttpStatusCode(res?.meta?.HttpStatusCode)
                        ) {
                          this.$toastr.s("Achiziția a fost salvată.");
                          this.reload();
                          this.setLoad();
                        } else {
                          error();
                        }
                      })
                      .catch(error);
                  },
                },
                customClass: "assignmentDocument-docs",
              },
              {
                name: "AddDocuments",
                adaptive: true,
                width: "1000",
                height: "1000",
              }
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });

      this.setLoad();
    },
    closeAssignmentDocument(item) {
      this.$modal.show(
        DialogModal,
        {
          target: "CloseAssignmentDocumentDocument",
          title: "Doriți să finalizați achiziția?",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Eroare la finalizarea achiziției.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              ASSIGNMENT_DOCUMENTS.closeAssignmentDocument(item.id, {
                status: "closed",
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Achiziția a fost finalizată.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "CloseAssignmentDocumentDocument",
          adaptive: true,
          width: "550",
          height: "300",
        }
      );
    },

    checkApproved(item) {
      this.setLoad(true);
      ASSIGNMENT_DOCUMENTS.checkApproved(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.reload();
            this.$toastr.s("Starea comenzii a fost modificată");
          } else {
            this.$toastr.w(res.response || "A apărut o eroare.");
            this.reload();
          }
        })
        .catch(() => {
          this.$toastr.e("A apărut o eroare.");
        });

      this.setLoad();
    },
  },

  computed: {
    ...mapGetters(["getProcedureTypes"]),
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    this.checkProduct(this.$route.query.aq);

    const canViewButtonsColumn = ["edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }

    GET_PAAP_CENTRALIZATION(this.$route.params.centralization).then((res) => {
      this.centralization = res.data;
      const path = this.$route.path;
      const val = path.slice(0, path.lastIndexOf("/"));

      this.$root.$emit("select-item", val.slice(0, val.lastIndexOf("/")));
    });
  },
};
</script>
<style>
.assignmentDocument-docs {
  max-width: 1200px !important;
  max-height: 1200px !important;
}

.custom-size {
  max-width: 1200px !important;
  max-height: 100% !important;
}
</style>
